(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants', '$uibModalInstance'];

    function RequestResetController($timeout, Auth, errorConstants, $uibModalInstance) {
        var vm = this;
        vm.errorEmailNotExists = null;
        vm.email = null;
        vm.success = null;
        vm.isSaving = false;
        vm.cancel = cancel;
        vm.requestReset = requestReset;

        $timeout(function () {
            angular.element('#email').focus();
        });

        function cancel() {
            vm.email = null;
            $uibModalInstance.dismiss('cancel');
        }

        function requestReset() {
            vm.errorEmailNotExists = null;
            vm.isSaving = true;
            Auth.resetPasswordInit(vm.email).then(function () {
                vm.isSaving = false;
                vm.success = 'OK';
                vm.email = null;
            }).catch(function (response) {
                vm.isSaving = false;
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
